export function getLocales() {
  const tag = typeof navigator !== 'undefined' ? navigator.language : 'pt-BR';
  const [languageCode, regionCode] = tag.split('-');
  return [{ languageTag: tag, languageCode, regionCode: regionCode ?? null, currencyCode: 'BRL', decimalSeparator: ',', digitGroupingSeparator: '.' }];
}
export function getCalendars() { return [{ timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }]; }
